export default "__VITE_ASSET__ByfHWqyM__"